import { useTranslation } from 'react-i18next';
import type { DragEvent } from 'react';

import { LECTURE_DRAG_TYPE } from './LectureLibraryTree';

export interface LectureDropZoneProps {
  label: string;
  onDrop: () => void;
}

// PO addition, not in Figma - a dashed ring over the canvas while a lesson row is being dragged
export function LectureDropZone({ label, onDrop }: LectureDropZoneProps) {
  const { t } = useTranslation('panels');
  function accept(event: DragEvent<HTMLDivElement>) {
    if (event.dataTransfer.types.indexOf(LECTURE_DRAG_TYPE) < 0) return;
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
  }

  return (
    <div className="lib-dropzone" aria-hidden={true} onDragEnter={accept} onDragOver={accept} onDrop={(event) => { event.preventDefault(); onDrop(); }}>
      <div className="lib-dropzone__ring"><span>{t('library.dropToOpen', { label })}</span></div>
    </div>
  );
}
